import axios from "axios";
import utils from "../utils";

const getAllFeedbacks = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/feedbacks`);
    // console.log("feedback_service.js - getAllFeedbacks response:", response);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }
  
    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const getOneFeedback = async (feedback_id) => {
  try {
    const response = await axios.get(`${utils.baseUrl}/feedbacks/${feedback_id}`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error);
  }
}

const updateOneFeedback = async (feedback_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/feedbacks/${feedback_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const deleteOneFeedback = async (feedback_id, data) => {
  try {
    const response = await axios.delete(`${utils.baseUrl}/feedbacks/${feedback_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

export default {
  getAllFeedbacks,
  getOneFeedback,
  updateOneFeedback,
  deleteOneFeedback
}